'use strict';
const $ = require('jquery');
window.$ = $;
window.jQuery = $;

import '../css/annual.scss';
require('bootstrap');
const enquire = require('enquire.js');

import adminMenu from '@elasticms/admin-menu';
import back2top from "./back2top";
import ajaxSearch from "./ajax-search";
import toc from "./toc";
import externalLink from "./external-link";
import HashFile from "./HashFile";
import common from "./common";
// import app from "./app";
import Highcharts from 'highcharts';
import initCollapse from './content-collapse';

import {stats} from './highcharts';

console.log('ragba website loaded!');

common();

$(function() {
  adminMenu();
  back2top();
  ajaxSearch();
  toc();
  // externalLink();
  initCollapse();
  stats.init();

  const $sidebar = $('#sidebar-menu');
  if($sidebar.length > 0) {
    sidebar_nav.init($sidebar);
  }
});

const sidebar_nav = {
  init: function($sidebar) {
    enquire.register("screen and (min-width:992px)", {
      match : function() {
        const $container = $('#main-content');
        let c_offset = $container.offset().top - 70;
        let s_height = $sidebar.height() + 70;
        let c_bottom = $container.offset().top + $container.height();
        let s_limit = c_bottom - s_height;

        let resizeTimer;

        $( window ).resize(function(e) {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(function(){
            c_offset = $container.offset().top - 70;
            s_height = $sidebar.height() + 70;
            c_bottom = $container.offset().top + $container.height();
            s_limit = c_bottom - s_height;
          }, 500);
        });

        $(window).on('scroll', function() {
          let wintop = $(window).scrollTop();

          $sidebar.toggleClass('menu-fixed', wintop > c_offset);
          $sidebar.toggleClass('menu-fixed-bottom', wintop > s_limit);
        });

        $('body').scrollspy({ 
          target: '#sidebar-menu',
          offset: 150
        });
      },
      unmatch : function() {
        $(window).unbind('scroll');
        $sidebar.removeClass('menu-fixed');
        $('body').scrollspy('dispose');
      }
    });

    $sidebar.find('a').click(function(e){
      e.preventDefault();
      const target = $($(this).attr('href'));
      sidebar_nav.smooth(target);
    });
  },
  smooth: function(target) {
    const offset = 48;
    $('html, body').animate({ scrollTop: target.offset().top - offset}, 1000);
  }
}